import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Conversion, Payment, Profit } from '../../../models/admModel/finance.model';
import * as config from '../backend.config';

// ----------------------------------------------
// Service for Administrator
// Component: finpaymentsComponent, finconversionsComponent, dashboardComponent
// ----------------------------------------------

const ADDRS_COMP_API = config.COMP_API + '/events';
const ADDRS_API = config.API;

// API description for all commnication with BACK-END for systemlog events management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS                                          Actions                   View
//  GET       api/adm/payments                              get all payments
//  GET       api/adm/profits                               get all profits
//  GET       api/adm/conversions                           get all conversions
//  GET       api/adm/conversions?status=${status}          get all conversions


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })

  export class SharedService {
    constructor(private http: HttpClient) { }

    // data for table from finpaymentsComponent
    getAllCountries(): Observable<any> {
        return this.http.get(ADDRS_API + '/countries');
      }

  }
